//TODO - this file is copied from Common project, import of exported utility functions is broken, it needs to be fixed
import { IData, PropertyGroupFromDataModel, TableHeaders } from '@blazemeter/blaze-data-ui';

export const shouldAddEmptyColumn = (data: string[][]) => {
  return data.some(cellValue => cellValue[cellValue.length - 1] !== '');
};

export const shouldAddEmptyRow = (data: string[][]) => {
  return data[data.length - 1].some(cellValue => cellValue !== '');
};

export const shouldDeleteEmptyColumn = (data: string[][], dynamicIndex: number) => {
  return !data.some(cellValue => cellValue[dynamicIndex] !== '');
};

export const shouldDeleteEmptyRow = (data: string[]) => {
  return !data.some(cellValue => cellValue !== '');
};

export const parameterSort = (a: string, b: string): number => {
  if (a === '') {
    return -1;
  } else if (a.toLowerCase() > b.toLowerCase()) {
    return 1;
  } else {
    return -1;
  }
};

export const getTableDataFromObject = (
  propertiesGroups: Array<{ name: string; properties: string[] }>,
  data: object[],
  pgName?: string,
) => {
  const tableHeaders = getTableHeaders(propertiesGroups, pgName);
  const rows: IData = generatedObjectToRows(data, tableHeaders);
  return { tableHeaders, rows };
};

function dataModelPreviewSort(a: PropertyGroupFromDataModel, b: PropertyGroupFromDataModel) {
  if (a.groupType && b.groupType) {
    const map = {};
    // @ts-ignore
    map['model'] = 1;
    // @ts-ignore
    map['csv'] = 2;
    // @ts-ignore
    map['far'] = 3;

    // @ts-ignore
    if (map[a.groupType] < map[b.groupType]) {
      return -1;
      // @ts-ignore
    } else if (map[a.groupType] > map[b.groupType]) {
      return 1;
    } else {
      return parameterSort(a.name, b.name);
    }
  }
  return parameterSort(a.name, b.name);
}

const getTableHeaders = (
  propertiesGroups: Array<{ name: string; displayName?: string; properties: string[] }>,
  pgName?: string,
) => {
  const tableHeaders: TableHeaders = { columns: [] };
  if (pgName) {
    tableHeaders.columns.push(
      ...propertiesGroups
        .find(v => v.name === pgName)!
        .properties.map(v => ({ title: v, width: 200, textContent: '' })),
    );
  } else {
    tableHeaders.nestedHeaders = [[]];
    const pgs = propertiesGroups.sort(dataModelPreviewSort);

    for (const pg of pgs) {
      const keys = pg.properties.map(v => ({ title: v, width: 200 }));
      tableHeaders.columns.push(...keys);
      tableHeaders.nestedHeaders[0].push({
        title: pg.name === 'default' ? `Synthetically Generated Parameters` : pg.displayName || pg.name,
        colspan: keys.length,
      });
    }
  }
  return tableHeaders;
};

const generatedObjectToRows = (generatedData: object[], tableHeaders: TableHeaders) => {
  const rows: IData = [];
  for (const data of generatedData) {
    const row: string[] = [];
    for (const col of tableHeaders.columns) {
      // @ts-ignore
      const value = data[col.title] ? data[col.title].toString() : '';
      if (value) {
        row.push(value);
      } else {
        row.push('');
      }
    }
    rows.push(row);
  }
  return rows;
};
